export const FLAG_GETTING_GEOGRAPHIC_ZONES = 'FLAG_GETTING_GEOGRAPHIC_ZONES';
export const GET_GEOGRAPHIC_ZONES = 'GET_GEOGRAPHIC_ZONES';
export const CLEAR_GEOGRAPHIC_ZONES = 'CLEAR_GEOGRAPHIC_ZONES';
export const FLAG_GEOGRAPHIC_ZONE_ACTIVITY = 'FLAG_GEOGRAPHIC_ZONE_ACTIVITY';
export const GET_GEOGRAPHIC_ZONE = 'GET_GEOGRAPHIC_ZONE';
export const CLEAR_GEOGRAPHIC_ZONE = 'CLEAR_GEOGRAPHIC_ZONE';
